import React from "react";
import "./AboutDescription.css";

import QuienesSomos from "../../images/quienes_somos.jpg";

export const AboutDescription = () => {
  return (
    <section className="about-us">
      <div className="about-us__container">
        <div className="about-us__text">
          <h1 className="about-us__title">Quienes somos?</h1>
          <p className="about-us__description">
            En el corazón de Puerto Escondido, donde las olas rompen con fuerza
            y la naturaleza dicta el ritmo de la vida, nace nuestra empresa con
            una pasión genuina por el surf. Nuestra inspiración proviene de mi
            propia vida como surfista, creciendo entre las fuertes olas del
            Pacífico y desarrollando una conexión inquebrantable con el mar.
            Desde mis primeras olas hasta los días en que el surf se convirtió
            en mi forma de vida, he aprendido que este deporte es libertad,
            respeto por la naturaleza y la búsqueda incansable de la ola
            perfecta.
            <br />
            <br />
            Nuestra filosofía está basada en un estilo de vida saludable y en
            armonía con el entorno. Creemos que el surf no solo es un deporte,
            sino una manera de vivir con autenticidad, equilibrio y alegría.
            Promovemos una visión integral que combina el entrenamiento físico,
            la alimentación consciente y la conexión con la naturaleza, pilares
            fundamentales para mejorar el desempeño y el disfrute en el agua.
            Nos aseguramos de que cada persona tenga la mejor experiencia, ya
            sea un principiante que siente por primera vez la fuerza del mar o
            un profesional buscando perfeccionar su estilo.
            <br />
            <br />
            En nuestra comunidad, el aprendizaje y el crecimiento personal van
            de la mano. Nos esforzamos por transmitir el conocimiento adquirido
            con los años, compartiendo secretos del océano, técnicas avanzadas y
            una actitud de respeto hacia el mar. Fomentamos la convivencia entre
            surfistas de todas partes del mundo, creando lazos que van más allá
            de las olas.
            <br />
            <br />
            Surfear no es solo deslizarse sobre el agua; es sentir la energía
            del océano, aprender a fluir con sus movimientos y entender su
            fuerza. En nuestra empresa, queremos compartir esta filosofía con
            todos aquellos que buscan en las olas una fuente de felicidad y
            conexión. Porque el surf no solo se practica, se vive.
          </p>
        </div>
        <div className="about-us__image-container">
          <img src={QuienesSomos} alt="About Us" className="about-us__image" />
        </div>
      </div>
    </section>
  );
};
